// ESM-Huelle um lib/scripts/pos/CLS_CBonManager.js (Phase 4, Welle 3c) -
// Bon-Manager-Hub: bindet die sechs Mixin-Module, definiert CBonEntry.
// Prototype-Stil bleibt vorerst.

// Die sechs Mixin-Module direkt importiert (erste echte Modul-Verkabelung -
// kein window-Umweg mehr innerhalb des Bundles).
import { CReceiptPrinter } from './receiptprinter.js';
import { CBunchOps } from './bunchops.js';
import { CBonRenderer } from './bonrenderer.js';
import { CBonEntryOps } from './bonentryops.js';
import { CRebateEngine } from './rebateengine.js';
import { CPaymentProcessor } from './paymentprocessor.js';
import { CBonTransaction } from './bontransaction.js';
import { parseRabattstufen } from './rabattstufen.js';
import { boniert as kiBoniert } from '../../pos/kiRueckmeldung.js';

function CBonEntry(index, type, unit, quantity, text1, text2, reference, amount, unitAmount, productId, vat) {

    var CBonEntryClass = this;
    this.defreturn = jQuery.Deferred();
    var def = jQuery.Deferred();
    // Populate with Type identifier
    // NIL - Undefined
    // POS - Position (Product + Amount)
    // MRB - Rebate for Position manual
    // ARB - Rebate for Position automatic
    // GRB - Global Rebate
    // CDS - Cash discount
    // CAN - Cancel of Position
    // PAY
    // RET
    this.type = type;
    // Populate with Unit
    // NIL - Undefined
    // PCS - Pieces
    // KGS - Kilograms
    // MTS - Meters
    // CMT - Centimeters
    //
    //
    this.unit = unit;
    // Populate with quantity, float value
    // Rebate populates percentage (0,05 - 5%)
    this.quantity = parseFloat(quantity);
    // Position Text
    this.text1 = text1;
    this.text2 = text2;
    // Reference to other position (eg Rebate for Position)
    this.reference = reference;
    // Referenced by
    this.referencedBy = new Array();
    // Amount of position
    this.amount = parseFloat(amount);
    // Amount per Unit
    this.unitAmount = unitAmount;
    // NodeId of Position Product
    this.productId = productId;

    if (this.type == "PDN") {
        CBonEntryClass.product = Trans.getPaydownData(vat);
        CBonEntryClass.text1 = CBonEntryClass.product.text1;
        CBonEntryClass.text2 = text2;
        def.resolve();
    } else if (productId && (CBonEntryClass.type != "REC" && CBonEntryClass.type != "FPR")) {
        $.when(Trans.getProductData(CBonEntryClass.productId)).then(function (prod) {
            CBonEntryClass.product = prod;
            if (!CBonEntryClass.product.valid) {
                CBonEntryClass.valid = false;
                def.reject();
                CBonEntryClass.defreturn.resolve(CBonEntryClass);
                return;
            }
            if (!CBonEntryClass.product.allowComma)
                CBonEntryClass.quantity = Math.floor(CBonEntryClass.quantity);
            CBonEntryClass.unit = CBonEntryClass.product.unit;
            CBonEntryClass.text1 = CBonEntryClass.product.text1;
            CBonEntryClass.text2 = CBonEntryClass.product.text2;
            CBonEntryClass.correctedPrice = CBonEntryClass.product.correctedPrice;

            if (amount == 0) {
                CBonEntryClass.unitAmount = fix2Decimals(CBonEntryClass.product.price);
                CBonEntryClass.amount = fix2Decimals(CBonEntryClass.quantity * CBonEntryClass.unitAmount);
            } else {
                // Amount of position
                CBonEntryClass.amount = parseFloat(amount);
                // Amount per Unit
                CBonEntryClass.unitAmount = unitAmount;
            }
            def.resolve();
        });
    } else if (productId && (CBonEntryClass.type == "REC" || CBonEntryClass.type == "FPR")) {

        $.when(Trans.getFreeProductData(CBonEntryClass.productId)).done(function (product) {
            CBonEntryClass.product = product;
            if (!CBonEntryClass.product.valid) {
                CBonEntryClass.valid = false;
                def.reject();
            }
            CBonEntryClass.text1 = CBonEntryClass.product.text1;
            CBonEntryClass.text2 = CBonEntryClass.product.text2;
            CBonEntryClass.defreturn.resolve(CBonEntryClass);
            def.resolve();
        });

    } else {
        CBonEntryClass.product = null;
        def.resolve();
    }

    $.when(def).done(function () {
        CBonEntryClass.cancelled = false;
        CBonEntryClass.index = index;
        CBonEntryClass.dbid = 0;
        CBonEntryClass.interaction = null;

        CBonEntryClass.valid = true;
        CBonEntryClass.defreturn.resolve(CBonEntryClass);
    });
}

function CBonManager(Bon, PaymentPanel, EntryBox, SumInfo, SumCaption, userProps, Main) {
    this.Bonus = new CHelloAgainAPI();
    this.printer = new CReceiptPrinter();
    this.bunch = new CBunchOps();
    this.renderer = new CBonRenderer();
    this.entryOps = new CBonEntryOps();
    this.rebates = new CRebateEngine();
    this.payment = new CPaymentProcessor();

    // Extracted-module delegates below are bound to THIS instance FIRST,
    // before anything else in this constructor runs - some constructor code
    // further down (e.g. this.initDisplay() near the end) already calls into
    // a delegated method while still constructing, so the modules above and
    // this binding must be ready before any other statement. Also: this
    // codebase passes bare method references around as later-invoked
    // callbacks in several places (e.g. POS.message.show(text, type, "YESNO",
    // BonManagerClass, BonManagerClass.doAddNewBunch), window.setTimeout(
    // BonManagerClass.initDisplay, 5000) - the callback gets invoked without
    // a receiver, so an unbound delegate would see `this` as undefined/global
    // instead of this CBonManager instance). Binding here makes every
    // extracted-module delegate behave exactly like a normal prototype
    // method regardless of how/when it's later passed around or invoked.
    var delegatedMethods = [
        'AddEntryPOSREG', 'printBarcode', 'printInvertedBon', 'printCustomerData',
        'printBon', 'getDisplayName', 'getStatus', 'isPaperPresent',
        'separateBunch', 'isBunchWorkPresent', 'addNewBunch', 'doAddNewBunch',
        'productChange', 'productExpiration', 'productRecovery', 'isBonStillNew',
        'redrawBon', 'toScanner', 'runRedrawBonArray', 'redrawAll', 'getEntrySum',
        'addEmptyLine', 'addLine', 'addRawLine', 'normalize', 'redrawBonSum',
        'addSumPaydownLine', 'addSumRawLine', 'addSumEmptyLine', 'getSumArray',
        'getBonVat', 'showSum', 'showRetour', 'showPos', 'switchSumInfo', 'initDisplay',
        'addEntryMVC', 'preAddEntryPOS', 'addEntryPOS', 'addEntryFREE', 'preAddEntryQTY',
        'addEntryQTY', 'addEntryPRC', 'addEntryCAN', 'cancelEntry', 'removePos',
        'correctQty', 'correctPrc', 'addNewPos', 'getSelectedItem', 'getProductName',
        'addDelivery', 'acceptDelivery', 'checkThreshold', 'checkCustomerThresholdPrice',
        'extractRebateSum', 'updateInstantRebate', 'findActiveRebateEntry', 'addEntryMRB',
        'addEntryGRB', 'addEntryCRB', 'addEntryCDS', 'addEntrySubREBS',
        'checkForRebateChanges', 'recalcAll', 'recalcAuto', 'loadSuggestion',
        'acceptSuggestion', 'doScaleSuggestion', 'grantRebPercent',
        'grantRebPercentFromTotal', 'grantRebAbsolute', 'grantRebAbsoluteFromTotal',
        'redrawBonSumAddRebate',
        'isCashPayment', 'isPPCCharge', 'addEntryPAY', 'makeCentralPayment',
        'makeDeliveryPayment', 'payCallback', 'closePayment', 'testPPCPaymentPing',
        'checkPPCPaymentAnswer', 'isRightPPUTime', 'makeDeliveryReceipt', 'openBon',
        'closeBon', 'cancelBon',
    ];
    for (var dmi = 0; dmi < delegatedMethods.length; dmi++) {
        this[delegatedMethods[dmi]] = this[delegatedMethods[dmi]].bind(this);
    }

    // Echte Globals (167+ Lesestellen in Classic-Skripten und Bon-Modulen) -
    // nach dem ESM-Umzug explizit auf window (die fruehere top-level
    // var-Deklaration + implizite Zuweisung traegt in Modulen nicht mehr).
    window.Trans = new CBonTransaction();
    window.Printer = new CPrinter();
    window.Display = new CDisplay();

    this.userProps = userProps;
    this.overridePriv = false;
    this.Main = Main;

    this.displayMode = "normal";
    this.displayTarget = null;

    this.printMode = "normal";
    this.barcode = null;
    this.dontSendScanner = false;
    this.isPaydown = false;
    this.wasPaydown = null;
    this.isPostCancelled = false;
    this.referenceBillId = null;
    this.showPaydownNote = false;
    this.activeRebatesFromBarcode = new Array();
    this.prepaidCardCredits = null;

    this.currentCustomerId = 0;
    this.currentCustomerEAN = 0;
    this.currentBonId = 0;
    this.isReclamationBon = false;
    this.currentBonPOSId = 0;
    this.currentBon = new Array(); // CBonEntry
    this.currentIndex = -1;
    this.gridLinks = new Array();
    this.gridLinksRow = new Array();
    this.gridLinksHeights = new Array();
    this.isProductRebate = new Array();
    this.vatSums = new Array();

    this.redrawBonArray = new Array();

    this.User = null;
    this.DateTime = null;
    this.Customer = null;

    if (typeof Bon != "undefined") {
        this.Bon = Bon;
        this.Grid = Bon.components.bon;
        this.SumGrid = Bon.components.bonSum;
        this.PaymentPanel = PaymentPanel;
        this.EntryBox = EntryBox;
        this.SumInfo = SumInfo;
        this.SumCaption = SumCaption;
    } else {
        this.Bon = null;
    }

    this.pendingPayment = new Array();

    this.sumLevels = new Array();
    this.sumLevels["POS"] = 0;
    this.sumLevels["PDN"] = 0;
    this.sumLevels["REC"] = 0;
    this.sumLevels["FPR"] = 0;
    this.sumLevels["MRB"] = 1;
    this.sumLevels["ARB"] = 1;
    this.sumLevels["GRB"] = 2;
    this.sumLevels["CRB"] = 3;
    this.sumLevels["CDS"] = 4;
    this.sumLevels["PAY"] = 5;
    this.sumLevels["RET"] = 6;

    this.initDisplay();

    // Stufen aus ini.txt ("Rabattstufen"), Voreinstellung wie bisher fest im Code.
    this.rebateZones = parseRabattstufen(window.POS && POS.EnvProperties && POS.EnvProperties.RABATTSTUFEN)
        .map(function (z) { return new RebateZone(z.min, z.max, z.percent); });

    this.currentIRBSum = 0;
    this.currentIRBPercent = 0;

    this.currentReceipt = null;
    this.printVC = false;

}

function RebateZone(min, max, percent) {
    this.min = min;
    this.max = max;
    this.percent = percent;
}

RebateZone.prototype.getRebate = function (sum) {
    if (this.percent != 0)
        if (sum >= this.min && ((this.max && sum < this.max) || !this.max))
            return this.percent / 100;

    return 0;
}

CBonManager.prototype.initDisplay = function () {
    return this.renderer.initDisplay.apply(this, arguments);
};

CBonManager.prototype.reset = function () {
    this.switchSumInfo(false);

    this.isProcessingPayment = false; // Doppelklick-Schutz aus payCallback() zuruecksetzen, siehe [[pos-bon-doppelzahlung-fix]]
    this.currentCustomerId = 0;
    this.currentCustomerEAN = 0;
    this.currentIndex = -1;
    this.currentBonId = 0;
    this.isReclamationBon = false;
    this.currentBonPOSId = 0;
    this.gridLinks = new Array();
    this.gridLinksRow = new Array();
    this.gridLinksHeights = new Array();
    this.currentBon = new Array();
    this.printMode = "normal";
    this.barcode = null;
    this.isPaydown = false;
    this.wasPaydown = null;
    this.isPostCancelled = false;
    this.referenceBillId = null;
    this.showPaydownNote = false;
    this.activeRebatesFromBarcode = new Array();
    this.prepaidCardCredits = null;
    this.isProductRebate = new Array();

    this.User = null;
    this.DateTime = null;
    this.Customer = null;

    this.currentIRBSum = 0;
    this.currentIRBPercent = 0;


    this.Grid.clear();
    this.SumGrid.clear();
    this.Grid.reDraw();
    this.SumGrid.reDraw();

    this.redrawBonArray = new Array();

    this.Main.InfoIcons.hideIcon("suggestion");
    this.Main.InfoIcons.hideIcon("customer");
    if (this.Main.components.payment2.children[6 - this.Main.components.payment.buttons.length]) {
        this.Main.components.payment2.children[6 - this.Main.components.payment.buttons.length].setEnabled(false);
    }
    this.Main.components.bonfnc.setEnabled(true);
    this.Main.components.payment.setEnabled(true);
    this.Main.components.payment2.setEnabled(true);
    this.Main.components.bonedit.setEnabled(true);
    this.Main.components.prodSelect.setEnabled(true);
    this.Main.components.leftPad.setEnabled(true);
}

CBonManager.prototype.openBon = function () {
    return this.payment.openBon.apply(this, arguments);
};

CBonManager.prototype.closeBon = function () {
    return this.payment.closeBon.apply(this, arguments);
};

CBonManager.prototype.addEntryMVC = function () {
    return this.entryOps.addEntryMVC.apply(this, arguments);
};

CBonManager.prototype.updateCustomerBon = function () {
    Trans.updateCustomerBon(this.currentBonId, this.currentCustomerId);
}

CBonManager.prototype.cancelBon = function () {
    return this.payment.cancelBon.apply(this, arguments);
};

CBonManager.prototype.isCashPayment = function () {
    return this.payment.isCashPayment.apply(this, arguments);
};

CBonManager.prototype.isPPCCharge = function () {
    return this.payment.isPPCCharge.apply(this, arguments);
};

CBonManager.prototype.AddEntryPOSREG = function () {
    return this.printer.AddEntryPOSREG.apply(this, arguments);
};

CBonManager.prototype.preAddEntryPOS = function () {
    // Pflanzenerkennung: das erste Produkt nach einer Erkennung ist das
    // Label der Trainingsdaten (pos/kiRueckmeldung.js). Nicht im Info-Modus -
    // dort wird nur nachgesehen, nicht boniert.
    if (this.displayMode != "info") {
        try { kiBoniert(arguments[1], this.currentBonId); } catch (e) { /* nie den Bon stoeren */ }
    }
    return this.entryOps.preAddEntryPOS.apply(this, arguments);
};

CBonManager.prototype.addEntryPOS = function () {
    return this.entryOps.addEntryPOS.apply(this, arguments);
};

CBonManager.prototype.extractRebateSum = function () {
    return this.rebates.extractRebateSum.apply(this, arguments);
};

CBonManager.prototype.updateInstantRebate = function () {
    return this.rebates.updateInstantRebate.apply(this, arguments);
};

CBonManager.prototype.addEntryFREE = function () {
    return this.entryOps.addEntryFREE.apply(this, arguments);
};
CBonManager.prototype.findActiveRebateEntry = function () {
    return this.rebates.findActiveRebateEntry.apply(this, arguments);
};

CBonManager.prototype.addEntryMRB = function () {
    return this.rebates.addEntryMRB.apply(this, arguments);
};

CBonManager.prototype.preAddEntryQTY = function () {
    return this.entryOps.preAddEntryQTY.apply(this, arguments);
};

CBonManager.prototype.addEntryQTY = function () {
    return this.entryOps.addEntryQTY.apply(this, arguments);
};

CBonManager.prototype.addEntryPRC = function () {
    return this.entryOps.addEntryPRC.apply(this, arguments);
};

CBonManager.prototype.addEntryCAN = function () {
    return this.entryOps.addEntryCAN.apply(this, arguments);
};

CBonManager.prototype.addEntryCDS = function () {
    return this.rebates.addEntryCDS.apply(this, arguments);
};

CBonManager.prototype.addEntryGRB = function () {
    return this.rebates.addEntryGRB.apply(this, arguments);
};

CBonManager.prototype.addEntryCRB = function () {
    return this.rebates.addEntryCRB.apply(this, arguments);
};

CBonManager.prototype.addEntryPAY = function () {
    return this.payment.addEntryPAY.apply(this, arguments);
};

CBonManager.prototype.makeCentralPayment = function () {
    return this.payment.makeCentralPayment.apply(this, arguments);
};

CBonManager.prototype.makeDeliveryPayment = function () {
    return this.payment.makeDeliveryPayment.apply(this, arguments);
};

CBonManager.prototype.payCallback = function () {
    return this.payment.payCallback.apply(this, arguments);
};

CBonManager.prototype.closePayment = function () {
    return this.payment.closePayment.apply(this, arguments);
};

CBonManager.prototype.testPPCPaymentPing = function () {
    return this.payment.testPPCPaymentPing.apply(this, arguments);
};

CBonManager.prototype.checkPPCPaymentAnswer = function () {
    return this.payment.checkPPCPaymentAnswer.apply(this, arguments);
};

CBonManager.prototype.isRightPPUTime = function () {
    return this.payment.isRightPPUTime.apply(this, arguments);
};

CBonManager.prototype.addEntrySubREBS = function () {
    return this.rebates.addEntrySubREBS.apply(this, arguments);
};

CBonManager.prototype.loadSuggestion = function () {
    return this.rebates.loadSuggestion.apply(this, arguments);
};

CBonManager.prototype.acceptSuggestion = function () {
    return this.rebates.acceptSuggestion.apply(this, arguments);
};

CBonManager.prototype.doScaleSuggestion = function () {
    return this.rebates.doScaleSuggestion.apply(this, arguments);
};

CBonManager.prototype.checkForRebateChanges = function () {
    return this.rebates.checkForRebateChanges.apply(this, arguments);
};

CBonManager.prototype.recalcAll = function () {
    return this.rebates.recalcAll.apply(this, arguments);
};

CBonManager.prototype.recalcAuto = function () {
    return this.rebates.recalcAuto.apply(this, arguments);
};

CBonManager.prototype.addNewPos = function () {
    return this.entryOps.addNewPos.apply(this, arguments);
};

CBonManager.prototype.redrawBon = function () {
    return this.renderer.redrawBon.apply(this, arguments);
};

CBonManager.prototype.toScanner = function () {
    return this.renderer.toScanner.apply(this, arguments);
};

CBonManager.prototype.runRedrawBonArray = function () {
    return this.renderer.runRedrawBonArray.apply(this, arguments);
};

CBonManager.prototype.redrawAll = function () {
    return this.renderer.redrawAll.apply(this, arguments);
};

CBonManager.prototype.getEntrySum = function () {
    return this.renderer.getEntrySum.apply(this, arguments);
};

CBonManager.prototype.addEmptyLine = function () {
    return this.renderer.addEmptyLine.apply(this, arguments);
};

CBonManager.prototype.addLine = function () {
    return this.renderer.addLine.apply(this, arguments);
};

CBonManager.prototype.addRawLine = function () {
    return this.renderer.addRawLine.apply(this, arguments);
};

CBonManager.prototype.normalize = function () {
    return this.renderer.normalize.apply(this, arguments);
};

CBonManager.prototype.redrawBonSum = function () {
    return this.renderer.redrawBonSum.apply(this, arguments);
};

CBonManager.prototype.redrawBonSumAddRebate = function () {
    return this.rebates.redrawBonSumAddRebate.apply(this, arguments);
};

CBonManager.prototype.addSumPaydownLine = function () {
    return this.renderer.addSumPaydownLine.apply(this, arguments);
};

CBonManager.prototype.addSumRawLine = function () {
    return this.renderer.addSumRawLine.apply(this, arguments);
};

CBonManager.prototype.addSumEmptyLine = function () {
    return this.renderer.addSumEmptyLine.apply(this, arguments);
};

CBonManager.prototype.getSumArray = function () {
    return this.renderer.getSumArray.apply(this, arguments);
};

CBonManager.prototype.getBonVat = function () {
    return this.renderer.getBonVat.apply(this, arguments);
};

CBonManager.prototype.loadFromId = function (id, leaveUser) {
    if (!leaveUser) {
        leaveUser = false;
    }
    var BonManagerClass = this;
    BonManagerClass.comesFromId = true;

    var defret = $.Deferred();
    $.when(Trans.load(id)).then(function (currentBon) {
        BonManagerClass.currentBon = currentBon;
        $.when(Trans.loadBonInfos(id)).then(function (infoArray) {
            if (infoArray) {
                BonManagerClass.User = infoArray["User"];
                BonManagerClass.DateTime = infoArray["DateTime"];
                BonManagerClass.Customer = infoArray["Customer"];
            } else {
                BonManagerClass.User = "";
                BonManagerClass.DateTime = "";
                BonManagerClass.Customer = "";
                log.add(2, "Error", "Returned in loadBonInfo null, Bon-ID:" + id);
            }

            if (!BonManagerClass.currentBon) {
                var text = POS.lang.getText("MESSAGES", "NO_VALID_BON_ID");
                POS.message.show(text, "critical", "OK");
                defret.resolve();
                return;
            }

            BonManagerClass.currentBonId = id;
            BonManagerClass.currentCustomerId = BonManagerClass.Customer;
            $.when(Trans.isPostCancelled(BonManagerClass.currentBonId)).then(function (val) {
                if (val)
                    BonManagerClass.isPostCancelled = true;
                $.when(BonManagerClass.getBonVat(false)).done(function () {
                    if (!BonManagerClass.Bon) {
                        defret.resolve();
                        return;
                    }

                    BonManagerClass.activeRebatesFromBarcode = new Array();
                    /*
                    for (var i in BonManagerClass.currentBon){
                    var e = BonManagerClass.currentBon[i];
                    if (!e.cancelled && e.type == "POS"){
                    var bc = Trans.isBarcodeRebate(e.productId);
                    if (bc)
                    BonManagerClass.activeRebatesFromBarcode.push(bc);
                    }
                    }*/

                    var cbs = Object.keys(BonManagerClass.currentBon);
                    var iterator = function it(i) {
                        if (i < cbs.length) {
                            var j = cbs[i];
                            var e = BonManagerClass.currentBon[j];
                            if (!e.cancelled && e.type == "POS") {
                                $.when(Trans.isBarcodeRebate(e.productId)).then(function (bc) {
                                    if (bc)
                                        BonManagerClass.activeRebatesFromBarcode.push(bc);
                                    iterator(i + 1);
                                    return;
                                });

                            } else {
                                iterator(i + 1);
                                return;
                            }

                        } else {
                            for (var i in BonManagerClass.currentBon) {
                                var PrimBonEntry = BonManagerClass.currentBon[i];

                                if (PrimBonEntry.type == "POS" || PrimBonEntry.type == "REC" ||
                                    PrimBonEntry.type == "FPR" || PrimBonEntry.type == "PDN")
                                    BonManagerClass.addNewPos(PrimBonEntry);
                            }

                            for (i = BonManagerClass.currentBon.length - 1; i >= 0; i--) {
                                if (!BonManagerClass.currentBon[i].cancelled) {
                                    BonManagerClass.currentIndex = i;
                                    break;
                                }
                            }

                            if (BonManagerClass.currentCustomerId) {
                                var def3 = BonManagerClass.updateInstantRebate()
                            } else {
                                def3 = 0;
                            }
                            $.when(def3).done(function () {
                                BonManagerClass.comesFromId = true;
                                $.when(BonManagerClass.runRedrawBonArray()).done(function () {
                                    BonManagerClass.comesFromId = false;
                                    $.when(BonManagerClass.redrawBonSum()).done(function () {
                                        if (!leaveUser) {
                                            var def4 = BonManagerClass.updateBonOwner(id, BonManagerClass.Main.userProps.Login, BonManagerClass.Main.userProps.Name);
                                        } else {
                                            def4 = 0;
                                        }

                                        $.when(def4).then(function () {

                                            log.add(4, "Info", "Bon loaded from ID = " + id, "");
                                            defret.resolve();
                                        });
                                    });
                                });
                            });
                            return;
                        }
                    }
                    iterator(0);

                });
            });
        });
    });
    return defret.promise();
}

CBonManager.prototype.updateBonOwner = function (bonId, userLogin, userName) {
    Trans.updateBonOwner(bonId, userLogin, userName);
}

CBonManager.prototype.getSelectedItem = function () {
    return this.entryOps.getSelectedItem.apply(this, arguments);
};

CBonManager.prototype.removePos = function () {
    return this.entryOps.removePos.apply(this, arguments);
};

CBonManager.prototype.correctQty = function () {
    return this.entryOps.correctQty.apply(this, arguments);
};

CBonManager.prototype.correctPrc = function () {
    return this.entryOps.correctPrc.apply(this, arguments);
};

CBonManager.prototype.grantRebPercent = function () {
    return this.rebates.grantRebPercent.apply(this, arguments);
};

CBonManager.prototype.grantRebPercentFromTotal = function () {
    return this.rebates.grantRebPercentFromTotal.apply(this, arguments);
};

CBonManager.prototype.grantRebAbsolute = function () {
    return this.rebates.grantRebAbsolute.apply(this, arguments);
};

CBonManager.prototype.grantRebAbsoluteFromTotal = function () {
    return this.rebates.grantRebAbsoluteFromTotal.apply(this, arguments);
};

CBonManager.prototype.showSum = function () {
    return this.renderer.showSum.apply(this, arguments);
};

CBonManager.prototype.showRetour = function () {
    return this.renderer.showRetour.apply(this, arguments);
};

CBonManager.prototype.showPos = function () {
    return this.renderer.showPos.apply(this, arguments);
};

CBonManager.prototype.switchSumInfo = function () {
    return this.renderer.switchSumInfo.apply(this, arguments);
};

CBonManager.prototype.inStockInput = function () {
    // TODO: �berpr�fen, dass der Bon richtig aufgebaut wurde.
    var me = this;

    $.when(Trans.inStockInput(this.currentBonId)).then(function () {
        Trans.closeBon(me.currentBonId, "SIN");
        me.reset();
    });

}

CBonManager.prototype.productExpiration = function () {
    return this.bunch.productExpiration.apply(this, arguments);
};

CBonManager.prototype.productRecovery = function () {
    return this.bunch.productRecovery.apply(this, arguments);
};

CBonManager.prototype.productChange = function () {
    return this.bunch.productChange.apply(this, arguments);
};

CBonManager.prototype.separateBunch = function () {
    return this.bunch.separateBunch.apply(this, arguments);
};

CBonManager.prototype.isBunchWorkPresent = function () {
    return this.bunch.isBunchWorkPresent.apply(this, arguments);
};

CBonManager.prototype.addNewBunch = function () {
    return this.bunch.addNewBunch.apply(this, arguments);
};

CBonManager.prototype.doAddNewBunch = function () {
    return this.bunch.doAddNewBunch.apply(this, arguments);
};

CBonManager.prototype.makeDeliveryReceipt = function () {
    return this.payment.makeDeliveryReceipt.apply(this, arguments);
};

CBonManager.prototype.isBonStillNew = function () {
    return this.bunch.isBonStillNew.apply(this, arguments);
};

CBonManager.prototype.printBarcode = function () {
    return this.printer.printBarcode.apply(this, arguments);
};

CBonManager.prototype.printInvertedBon = function () {
    return this.printer.printInvertedBon.apply(this, arguments);
};

CBonManager.prototype.printCustomerData = function () {
    return this.printer.printCustomerData.apply(this, arguments);
};
CBonManager.prototype.printBon = function () {
    return this.printer.printBon.apply(this, arguments);
};

CBonManager.prototype.getDisplayName = function () {
    return this.printer.getDisplayName.apply(this, arguments);
};

CBonManager.prototype.getStatus = function () {
    return this.printer.getStatus.apply(this, arguments);
};

CBonManager.prototype.isPaperPresent = function () {
    return this.printer.isPaperPresent.apply(this, arguments);
};

CBonManager.prototype.cancelEntry = function () {
    return this.entryOps.cancelEntry.apply(this, arguments);
};

CBonManager.prototype.isBonEmpty = function () {
    for (var cnt in this.currentBon) {
        var Entry = this.currentBon[cnt];
        if (Entry.type == "POS" && !Entry.cancelled)
            return false;
    }
    return true;
}

CBonManager.prototype.getProductName = function () {
    return this.entryOps.getProductName.apply(this, arguments);
};

CBonManager.prototype.addDelivery = function () {
    return this.entryOps.addDelivery.apply(this, arguments);
};

CBonManager.prototype.acceptDelivery = function () {
    return this.entryOps.acceptDelivery.apply(this, arguments);
};

CBonManager.prototype.recoverPaydownBon = function (bonId) {

    var defret = $.Deferred();
    var BonManagerClass = this;
    $.when(Trans.isStillPaydown(bonId)).then(function (val) {
        if (!val) {
            var text = POS.lang.getText("MESSAGES", "BON_ALREADY_PAID");
            POS.message.show(text, "warning", "OK");
            return;
        }

        BonManagerClass.reset();

        $.when(Trans.getPaydownBonInUse(bonId)).then(function (newBonId) {
            var def = $.Deferred();
            if (newBonId == -1) {
                $.when(Trans.openBon()).then(function (nBonId) {
                    $.when(Trans.makeBonCopy(bonId, nBonId)).done(function () {
                        $.when(Trans.setPaydowns(bonId, nBonId)).then(function () {
                            newBonId = nBonId;
                            def.resolve();
                        });
                    });
                });
            } else {
                def.resolve();
            }
            $.when(def).then(function () {
                BonManagerClass.wasPaydown = bonId;
                $.when(BonManagerClass.loadFromId(newBonId)).done(function () {
                    defret.resolve();
                });
            });
        });
    });
    return defret.promise();
}

CBonManager.prototype.copyBon = function (bonId) {
    this.reset();
    var defret = $.Deferred();
    var BonManagerClass = this;
    $.when(Trans.openBon()).then(function (newBonId) {
        $.when(Trans.copyBonPos(bonId, newBonId)).then(function () {
            $.when(BonManagerClass.loadFromId(newBonId)).done(function () {
                defret.resolve();
            });
        });
    });
    return defret.promise();
}

CBonManager.prototype.wholeNetto = function () {

    var defret = $.Deferred();

    $.when(this.getBonVat(true)).done(function (vG) {
        var vatGrid = vG;
        var sum = 0;

        for (var i in vatGrid["net"])
            sum += parseFloat(vatGrid["net"][i]);
        defret.resolve(sum);
    });
    return defret.promise();
}

CBonManager.prototype.checkThreshold = function () {
    return this.entryOps.checkThreshold.apply(this, arguments);
};

CBonManager.prototype.checkCustomerThresholdPrice = function () {
    return this.entryOps.checkCustomerThresholdPrice.apply(this, arguments);
};

export { CBonManager, CBonEntry };
